module.exports = __webpack_public_path__ + "static/media/Yoga.df5dba7e.webp";